import customFetch from './customFetch';

/**
 * Schliesst eine Web-Bestellung nach der Zahlung ab (Karten, Mails) und
 * liefert den Zahlungsstand: 'paid' | 'processing' | 'open' | 'expired'.
 *
 * null heisst: der Server war nicht erreichbar. Kein Grund zur Panik — der
 * Stripe-Webhook schliesst eine bezahlte Bestellung auch ohne diesen Aufruf ab.
 */
const confirmOrderPayment = async (orderId) => {
  try {
    const { data } = await customFetch.post(
      `/orders/${orderId}/confirm-payment`
    );
    return data.status;
  } catch (error) {
    return null;
  }
};

export default confirmOrderPayment;
